import { api, type SectionDraftDetail } from '../../api/client'
import type { PhotoRequest } from './photoHelp'

const SD = '/api/lab/section-drafts'

/** The newest requests on the piece, newest first. */
export const listPhotoHelp = (id: number) => api.get<{ on: boolean; requests: PhotoRequest[] }>(`${SD}/${id}/photo-help`)

export const askPhotoHelp = (id: number, instruction: string) => api.post<PhotoRequest>(`${SD}/${id}/photo-help`, { instruction })

/** Apply the listed changes, or all of them (null). Returns the piece as it now stands. */
export const applyPhotoHelp = (id: number, reqId: number, changeIds: string[] | null) =>
  api.post<{ detail: SectionDraftDetail; request: PhotoRequest }>(`${SD}/${id}/photo-help/${reqId}/apply`, { change_ids: changeIds })

export const discardPhotoHelp = (id: number, reqId: number, changeIds: string[] | null) =>
  api.post<{ request: PhotoRequest }>(`${SD}/${id}/photo-help/${reqId}/discard`, { change_ids: changeIds })
